import React from 'react';

import { get as getConstants } from '@lumapps/constants';
import { useDispatch } from '@lumapps/redux/react';

import { AppId } from '../constants';
import { actions } from '../ducks/slice';
import { setCurrentPage } from '../ducks/thunks';
import { useCurrentRoute } from './useCurrentRoute';
import { usePreviousRoute } from './usePreviousRoute';
import { useRouter } from './useRouter';

const { applicationId } = getConstants();
const ENABLED_APPS_FOR_ON_AFTER_ROUTE = [AppId.frontOffice, AppId.backOffice, AppId.webview];

/**
 * Will update the redux store with the pageId each time it change
 * @param id identifier of the page
 * @param shouldDispatchToCusto should we dispatch the event to customization api?
 */
export const useCurrentPageEffect = (id: string, shouldDispatchToCusto: boolean) => {
    const dispatch = useDispatch();
    const currentRoute = useCurrentRoute();
    const previousRoute = usePreviousRoute();
    const { onAfterRoute } = useRouter();

    React.useEffect(() => {
        dispatch(setCurrentPage(id, shouldDispatchToCusto));
    }, [id, dispatch, shouldDispatchToCusto]);

    React.useEffect(() => {
        if (ENABLED_APPS_FOR_ON_AFTER_ROUTE.includes(applicationId)) {
            dispatch(actions.setCurrentRoute(currentRoute));

            if (onAfterRoute && previousRoute) {
                onAfterRoute(previousRoute, currentRoute);
            }
        }
    }, [currentRoute, dispatch, onAfterRoute, previousRoute]);
};
